import { render, staticRenderFns } from "./NewMemberAreaQuizz.vue?vue&type=template&id=23d7d43c&scoped=true&"
import script from "./NewMemberAreaQuizz.vue?vue&type=script&lang=js&"
export * from "./NewMemberAreaQuizz.vue?vue&type=script&lang=js&"
import style0 from "./NewMemberAreaQuizz.vue?vue&type=style&index=0&id=23d7d43c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d7d43c",
  null
  
)

export default component.exports